export default __webpack_public_path__ + "static/media/client11.c4867249.jpg";